/* chat_mobil_guard.js - Codex v50 Befund 1 (Nachtplan q49/q54), 11.10.2026, Theme-Kopie "sanierung-ui 11.10.".
 * Mobil (max. 767 px) verdeckt der geschlossene Chat-Knopf beim Scrollen die Wildvogel-Kachel der Startseite.
 * Solange sich der Knopf und die sichtbare Kachelfläche schneiden, bekommt <body> die Klasse
 * "tfp-chat-occludes-cta"; assets/chat_mobil.css blendet dann nur den Knopf (::part(activator)) aus.
 * Nie ausgeblendet: geöffneter Chat-Dialog, Knopf/Chat mit Fokus. Messung per requestAnimationFrame gebündelt.
 * DOM (geprüft 11.10.): shopify-chat > #shadow > shopify-agent-runtime > #shadow > button[part~=activator], section[part~=dialog].
 * Eingebunden nur auf der Startseite (snippets/theme-style.liquid). Rückbau: Script-Zeile dort entfernen.
 */
(function () {
  if (window.__tfpChatGuard) return;
  window.__tfpChatGuard = true;

  var CLS = 'tfp-chat-occludes-cta';
  var TILE = '[id$="__tfp_wildvogel_direkt"] .tfp-cats__link';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var queued = false;
  var observed = null;

  function chatParts() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    var roots = [host.shadowRoot];
    var rt = host.shadowRoot.querySelector('shopify-agent-runtime');
    if (rt && rt.shadowRoot) roots.unshift(rt.shadowRoot);
    for (var i = 0; i < roots.length; i++) {
      var a = roots[i].querySelector('[part~="activator"]');
      if (a) return { host: host, activator: a, dialog: roots[i].querySelector('[part~="dialog"]') };
    }
    return null;
  }

  function visibleRect(el) {
    var r = el.getBoundingClientRect();
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var top = Math.max(r.top, 0), bottom = Math.min(r.bottom, vh);
    var left = Math.max(r.left, 0), right = Math.min(r.right, vw);
    if (r.width === 0 || r.height === 0 || bottom <= top || right <= left) return null;
    return { top: top, bottom: bottom, left: left, right: right };
  }

  function intersects(a, b) {
    return a && b && a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }

  function dialogOpen(p) {
    if (!p.dialog) return false;
    var r = p.dialog.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function measure() {
    queued = false;
    var on = false;
    var p = chatParts();
    if (p && (!mq || mq.matches)) {
      watchDialog(p);
      var focused = document.activeElement === p.host;
      if (!focused && !dialogOpen(p)) {
        var tiles = document.querySelectorAll(TILE);
        var act = p.activator.getBoundingClientRect();
        if (act.width > 0 && act.height > 0) {
          for (var i = 0; i < tiles.length && !on; i++) on = intersects(act, visibleRect(tiles[i]));
        }
      }
    }
    document.body.classList.toggle(CLS, on);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(measure);
  }

  /* Chat-Zustand (Dialog auf/zu) kommt ohne Scroll-Ereignis: Dialog-Attribute beobachten. */
  function watchDialog(p) {
    if (!p.dialog || observed === p.dialog || !('MutationObserver' in window)) return;
    observed = p.dialog;
    new MutationObserver(schedule).observe(p.dialog, { attributes: true });
    new MutationObserver(schedule).observe(p.activator, { attributes: true });
  }

  function boot() {
    if (!document.querySelector(TILE)) return;
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    document.addEventListener('focusin', schedule, true);
    document.addEventListener('focusout', schedule, true);
    document.addEventListener('click', schedule, true);
    if (mq && mq.addEventListener) mq.addEventListener('change', schedule);
    /* Der Chat lädt nach: bis zu 30 s lang alle 1 s nachsehen, bis der Knopf da ist. */
    var tries = 0;
    (function wait() {
      schedule();
      if (chatParts() || ++tries >= 30) return;
      setTimeout(wait, 1000);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
